import { render } from "./scenario-overview.vue?vue&type=template&id=4652ac70&ts=true"
import script from "./scenario-overview.vue?vue&type=script&lang=ts"
export * from "./scenario-overview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__